import { render, staticRenderFns } from "./DetailsDateInput.vue?vue&type=template&id=bfb6a402&scoped=true"
import script from "./DetailsDateInput.vue?vue&type=script&lang=ts"
export * from "./DetailsDateInput.vue?vue&type=script&lang=ts"
import style0 from "./DetailsDateInput.vue?vue&type=style&index=0&id=bfb6a402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb6a402",
  null
  
)

export default component.exports